var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserSwitch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M11.333 11.333a1.667 1.667 0 1 1 0-3.333 1.667 1.667 0 0 1 0 3.333m0 0a3 3 0 0 1 3 3m-3-3a3 3 0 0 0-3 3M4.667 5a1.667 1.667 0 1 1 0-3.333 1.667 1.667 0 0 1 0 3.333m0 0a3 3 0 0 1 3 3m-3-3a3 3 0 0 0-3 3M2.333 10.333a3.33 3.33 0 0 0 3.334 3.334l-.334-1.334M12.333 5.667A3.33 3.33 0 0 0 9 2.333l.333 1.334"
})));
export { SvgUserSwitch as ReactComponent };
export default __webpack_public_path__ + "static/media/UserSwitch.13cb3bd5.svg";